import Testimonial from '@/page-components/Home/Testimonials/Testimonial';
import TestimonialSection from '@/page-components/Home/TestimonialSection/TestimonialSection';
import ImageWithText from '@/page-components/Home/ImageWithText/ImageWithText';
import ImageWithTextSize from '@/page-components/Home/ImageWithTextSize/ImageWithText';
import ImageTextFeatures from '@/page-components/Home/ImageTextFeatures/ImageTextFeatures';
import ImageTextLabel from '@/page-components/Home/ImageTextLabel/ImageTextLabel';
// import Hero from '@/page-components/Home/Hero/Hero';
import HeroNew from '@/page-components/Home/HeroNew/Hero';
import PersonaliseCapsule from '@/page-components/Home/PersonaliseCapsule/PersonaliseCapsule';
import Invite from '@/page-components/Home/Invite/Invite';
import Slider from '@/page-components/Home/Slider/Slider';
import ImageWithVideo from '@/page-components/Home/ImageWithVideo/ImageWithVideo';
import CTA from '@/components/CTA';
import Features from '@/page-components/Home/Features/Features';
import HowItWorks from '@/page-components/Home/Personalization/Personalization';
import HowItWorksSubtitle from '@/page-components/Home/HowItWorksSubtitle/HowItWorksSubtitle';
import HowItWorksMembership from '@/page-components/Membership/HowItWorksMembership/MembershipSteps';
import HeroText from '@/components/HeroText/HeroText';
import ImageWithList from '@/page-components/Precision/ImageWithText/ImageWithList';
import GetToKnowMore from '@/page-components/Home/GetToKnowMore/GetToKnowMore';
import FAQ from '@/page-components/Home/FAQ/FAQ';
import ComparisonSection from '@/components/Comparison/Comparison';
import TitleDescription from '@/page-components/Manifest/TitleDescription/TitleDescription';
import IngredientsContent from '@/page-components/Ingredients/IngredientsContent';
import ContactUsDetails from '@/page-components/Contact/ContactUsDetails';
import Team from '@/components/Team/Team';
import OtherBlogsPost from '@/page-components/BlogPost/OtherBlogs/OtherBlogs';
import Banner from '@/components/Banner/Banner';
import Foundation from '@/page-components/SciencePage/Foundation/Foundation';
import Benefits from '@/page-components/Precision/Benefits/Benefits';
import FeaturesWide from '@/components/FeaturesWide/FeaturesWide';
import Countdown from '@/components/Countdown/Countdown';
import Offer from '@/components/Offer/Offer';
import ImageWithHTML from '@/page-components/Home/ImageWithHTML/ImageWithHTML';
import TextIconCards from '@/page-components/Ingredient/TextIconCards/TextIconCards';
import SideImageWithInfoCards from '@/page-components/Ingredient/SideImageWithInfoCards/SideImageWithInfoCards';
import ReferencesCards from '@/page-components/Ingredient/ReferencesCards/ReferencesCards';
import { ClinicalInfoTable } from '@/page-components/Ingredient/ClinicalInfoTable/ClinicalInfoTable';
import HeroSideImage from '@/components/HeroSideImage/HeroSideImage';
import IngredientCards from '@/page-components/Goal/IngredientCards/IngredientCards';
import RichContent from '@/components/RichContent/RichContent';
import NumberedSteps from '@/page-components/Home/NumberedSteps/NumberedSteps';
import ImageCards from '@/page-components/Home/ImageCards/ImageCards';
import PlansLight from '@/page-components/Home/PlansLight/Plans';
import PlansFull from '@/page-components/Home/PlansFull/Plans';
import LaunchOffer from '@/page-components/Home/LaunchOffer/LaunchOffer';

export enum PageSections {
  // home components
  PersonaliseCapsuleSection = 'homepage.product-overview-section',
  InviteSection = 'homepage.email-signup-section',

  // precision components
  Comparison = 'precision.comparison-section',
  FeaturePanel = 'precision.feature-panel-section',

  // contact us components
  ContactUs = 'contact-us.contact-us-section',

  // blog components
  OtherBlogs = 'blog.other-blogs-section',

  // about us components
  TeamSection = 'about-us.team-section',

  // backed by science components
  FoundationSection = 'backed-by-science.features-section',

  // membership components
  BenefitsSection = 'membership.feature-section',

  // ingredient components
  TextIconCardsSection = 'ingredient.text-icon-cards-section',
  SideImageWithInfoCardsSection = 'ingredient.side-image-with-info-cards',
  References = 'ingredient.references',
  IngredientListSection = 'ingredient.ingredient-list',

  // shared components
  ImageWithTextSection = 'shared.image-text',
  ImageWithTextSizeSection = 'shared.image-text-size',
  TitleDescriptionSection = 'shared.title-description-card',
  ImageWithTextListSection = 'shared.cards-image-text-list',
  HeroSection = 'shared.hero-section',
  // HeroWithDarkBackgroundSection = 'shared.hero-section-dark-background',
  HeroWithDarkBgSectionNew = 'shared.hero-section-dark-background',
  HeroWithSideImage = 'shared.hero-section-side-image',
  RichContentSection = 'shared.rich-content-block',
  VideoSection = 'shared.video-section',
  FAQSection = 'shared.faq-section',
  HowItWorksSection = 'shared.how-it-works-section',
  HowItWorksSubtitleSection = 'shared.how-it-works-subtitle-section',
  HowItWorksMembershipSection = 'membership.membership-how-it-works-section',
  FeaturesSection = 'shared.upgrade-system-cards',
  Review = 'shared.review-section',
  IngredientsSection = 'shared.button-text-card',
  SliderSection = 'shared.slider',
  SliderDynamicCards = 'shared.slider-dynamic-cards',
  BannerSection = 'shared.banner-section',
  CTASection = 'shared.cta-background-accordions-section',
  FeaturesWideSection = 'shared.upgrade-system-wide-cards',
  CountdownSection = 'shared.countdown',
  OfferSection = 'membership.introductory-offer-section',
  ImageWithHTMLSection = 'shared.cards-icon-html-list',
  TableSection = 'shared.table-section',
  NumberedStepsSection = 'shared.numbered-steps-section',
  ImageTextFeaturesSection = 'shared.image-text-features',
  ImageTextLabelSection = 'shared.image-text-label',
  TestimonialBlockSection = 'shared.testimonial-section',
  ImageCardsSection = 'shared.image-cards-section',
  PlansLightSection = 'shared.membership-plans-section-light',
  PlansFullSection = 'shared.membership-plans-section',
  LaunchOfferSection = 'shared.launch-offer-section',
}

export const pageComponents = {
  // home components
  [PageSections.PersonaliseCapsuleSection]: PersonaliseCapsule,
  [PageSections.InviteSection]: Invite,
  [PageSections.CTASection]: CTA,

  // precision components
  [PageSections.Comparison]: ComparisonSection,
  [PageSections.FeaturePanel]: GetToKnowMore,

  // contact us components
  [PageSections.ContactUs]: ContactUsDetails,

  // blog components
  [PageSections.OtherBlogs]: OtherBlogsPost,

  // about us components
  [PageSections.TeamSection]: Team,

  // backed by science components
  [PageSections.FoundationSection]: Foundation,

  // membership components
  [PageSections.BenefitsSection]: Benefits,

  // ingredient components
  [PageSections.TextIconCardsSection]: TextIconCards,
  [PageSections.SideImageWithInfoCardsSection]: SideImageWithInfoCards,
  [PageSections.References]: ReferencesCards,
  [PageSections.IngredientListSection]: IngredientCards,

  // shared components
  [PageSections.ImageWithTextSection]: ImageWithText,
  [PageSections.TitleDescriptionSection]: TitleDescription,
  [PageSections.ImageWithTextListSection]: ImageWithList,
  [PageSections.HeroSection]: HeroText,
  // [PageSections.HeroWithDarkBackgroundSection]: Hero,
  [PageSections.HeroWithDarkBgSectionNew]: HeroNew,
  [PageSections.HeroWithSideImage]: HeroSideImage,
  [PageSections.RichContentSection]: RichContent,
  [PageSections.VideoSection]: ImageWithVideo,
  [PageSections.FAQSection]: FAQ,
  [PageSections.HowItWorksSection]: HowItWorks,
  [PageSections.FeaturesSection]: Features,
  [PageSections.Review]: Testimonial,
  [PageSections.IngredientsSection]: IngredientsContent,
  [PageSections.SliderSection]: Slider,
  [PageSections.SliderDynamicCards]: Slider,
  [PageSections.BannerSection]: Banner,
  [PageSections.FeaturesWideSection]: FeaturesWide,
  [PageSections.CountdownSection]: Countdown,
  [PageSections.OfferSection]: Offer,
  [PageSections.ImageWithHTMLSection]: ImageWithHTML,
  [PageSections.TableSection]: ClinicalInfoTable,
  [PageSections.NumberedStepsSection]: NumberedSteps,
  [PageSections.ImageWithTextSizeSection]: ImageWithTextSize,
  [PageSections.ImageTextFeaturesSection]: ImageTextFeatures,
  [PageSections.HowItWorksSubtitleSection]: HowItWorksSubtitle,
  [PageSections.HowItWorksMembershipSection]: HowItWorksMembership,
  [PageSections.ImageTextLabelSection]: ImageTextLabel,
  [PageSections.TestimonialBlockSection]: TestimonialSection,
  [PageSections.ImageCardsSection]: ImageCards,
  [PageSections.PlansLightSection]: PlansLight,
  [PageSections.LaunchOfferSection]: LaunchOffer,
  [PageSections.PlansFullSection]: PlansFull,
};
